import { AppLink } from "../components/app-link.js";
import { PageState } from "../components/page-state.js";
import { PATHS } from "../lib/routes.js";

/**
 * What every page of a workspace shows once its access has ended "closed"
 * (DESIGN.md, "Access and plans"). The server says so; nothing of the plan is
 * drawn, because plans are not shown in the app.
 */
export function WorkspaceClosed() {
  return (
    <PageState
      title="This workspace is closed"
      actions={
        <AppLink href={PATHS.profile} className="button-secondary">
          Your account
        </AppLink>
      }
    >
      Its access has ended. Your reports and questions are kept. Write to the Crux team to
      open it again.
    </PageState>
  );
}
